import React, { Component, useState,useEffect  } from 'react';
import Voting from "./Voting";
import Advert from "./Advert";
import classNames  from "classnames";
import BVoting from "./BVoting";
import Articles from "./Articles";
import BASVoting from "./BASVoting";


class BASVindex extends Component {
	constructor(props){
		super(props);
		this.state = {
			alldata: null,
		}
		console.log(this.state.alldata);
		this.getVotes = this.getVotes.bind(this);
		//this.changePhase = this.changePhase.bind(this);
		// this.vote = this.vote.bind(this);
		// this.openvote = this.openvote.bind(this);

	}

	triggerEvent (SheVoteAction, SheVoteValue) {
		dataLayer.push({event: "She Vote", virtualPageURL: location.href, SheVoteAction, SheVoteValue})
	}


	getVotes(){
		let that = this;
		var myHeaders = new Headers();

		myHeaders.append('pragma', 'no-cache');
		myHeaders.append('cache-control', 'no-cache');
		fetch('/wp-json/she-rest-api/getBASVotes/'+that.props.year+'/'+that.props.sessionid,{
			method:"POST",
			headers: myHeaders
		}).then(function(res){
			return res.json();
		})
		.then(function(response){
			that.setState({alldata: response});
			console.log(this.state.alldata);
			return response;
		}).catch(function(error){
			console.error(error);
		});
		console.log(this.state.alldata);
	}

	// changePhase(phase){
	// 	this.setState({phase: phase});
	// 	this.setState({alldata: null});
	// 	this.forceUpdate();
	// 	setTimeout(() => {
	// 		this.getVotes(this.props.vid);
	// 		this.forceUpdate();
	// 	}, 500);
	//
	// }

	 toChineseNumber(n) {
		if (!Number.isInteger(n) && n < 0) {
			throw Error('');
		}

		const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
		const positions = ['', '十', '百', '千', '萬', '十萬', '百萬', '千萬', '億', '十億', '百億', '千億'];
		const charArray = String(n).split('');
		let result = '';
		let prevIsZero = false;
		//处理0  deal zero
		for (let i = 0; i < charArray.length; i++) {
			const ch = charArray[i];
			if (ch !== '0' && !prevIsZero) {
				result += digits[parseInt(ch)] + positions[charArray.length - i - 1];
			} else if (ch === '0') {
				prevIsZero = true;
			} else if (ch !== '0' && prevIsZero) {
				result += '零' + digits[parseInt(ch)] + positions[charArray.length - i - 1];
			}
		}
		//处理十 deal ten
		if (n < 100) {
			result = result.replace('一十', '十');
		}
		return result;
	}




	componentDidMount(){
		this.getVotes();
	}


	render(){
		const {alldata,phase} = this.state;
		const {year,role, code} = this.props;
		let that = this;
		// let ssrow=[];
		// let fwrow=[];
		// if (year ==2021){
		// 	for (let i = 1; i <= ss; i++) {
		// 		let pid = year+'06'+i;
		// 		let active = '';
		//
		// 		if (pid == phase){
		// 			active = 'active';
		// 		}
		// 		ssrow.push(<button onClick={that.changePhase.bind(this,pid)} className={active}>第{this.toChineseNumber(i)}輪投票</button>)
		//
		//
		// 	}
		// }else{
		//
		// }
		//
		// if (month =='06'){
		// 	for (let i = 1; i <= ss; i++) {
		// 		let pid = year+'06'+i;
		// 		let active = '';
		//
		// 		if (pid == phase){
		// 			active = 'active';
		// 		}
		// 		ssrow.push(<button onClick={that.changePhase.bind(this,pid)} className={active}>春夏SS第{this.toChineseNumber(i)}輪投票</button>)
		//
		//
		// 	}
		// }
		// if (month =='12'){
		// 	for (let i = 1; i <= fw; i++) {
		// 		let pid = year+'12'+i;
		// 		let active = '';
		//
		// 		if (pid == phase){
		// 			active = 'active';
		// 		}
		// 		fwrow.push(<button onClick={that.changePhase.bind(this,pid)} className={active}>秋冬FW第{this.toChineseNumber(i)}輪投票</button>)
		// 	}
		// }
		//
		// let phases = <div className="phase-section">{ssrow}{fwrow}</div>
		if (alldata === null) {
			return (
				<div >

				</div>
			);
		}

		console.log(alldata.length);
		if (alldata.length === 0) {
			return (
				<div >
					<div className="ba-announce">
						這一輪投票暫未開始
					</div>
					<div id="ba-articles">
						<Articles baseurl={document.querySelector('meta[name="baseURL"]').content} theme={"she.com"} author=""  catId="" subcat="" section={"beautyaward"} apiLabel={document.querySelector('meta[name="apiLabel"]').content} replaceTitle="" postId="" year={this.props.year}/>
					</div>

				</div>
			);
		}
		const half= Math.round(alldata.length / 2);
		const firsthalf = alldata.slice(0, half);
		const lasthalf = alldata.slice(half, alldata.length);

		return <div >
			<div className="whole-full-ba">
				<div className="whole-ba">
					<div className="ba-half">
						{
							firsthalf?
								firsthalf.map(function(item, index) {
									return <BASVoting key={index} vid={item}  role={role} code={code}/>
								}):''
						}
					</div>
					<div className="ba-half">
						{
							lasthalf?
								lasthalf.map(function(item, index) {
									return <BASVoting key={index} vid={item}  role={role} code={code}/>
								}):''
						}
					</div>
				</div>
			</div>


			<div id="ba-articles">
				<Articles baseurl={document.querySelector('meta[name="baseURL"]').content} theme={"she.com"} author=""  catId="" subcat="" section={"beautyaward"} apiLabel={document.querySelector('meta[name="apiLabel"]').content} replaceTitle="" postId="" year={this.props.year}/>
			</div>
		</div>
	}

}

export default BASVindex



// WEBPACK FOOTER //
// ./src/BASVindex.js